import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[kalTabContent]',
    standalone: false
})
export class KalTabContentDirective {

  constructor(public template: TemplateRef<any>) {
  }

}
